const data = [
  {
    account: "janavydrova",
    items_count: 2,
    id: "nzcyq",
    url: "https://www.ekomejl.cz/data-feed.xml",
    error: null,
    synced_at: "2024-10-10 02:00:39",
    name: "https://www.ekomejl.cz/data-feed.xml",
    timestamp: "p\u0159ed 5 hodinami",
    synced_at_iso: "2024-10-10T02:00:39+00:00",
  },
];

export const getDynamicFeeds = () => {
  return new Response(
    JSON.stringify({
      success: true,
      data: data,
    }),
    {
      status: 200,
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};
